@import './ui-cms-sticky-toolbar';

:host {
  width: auto;
  z-index: 65536; // index > edit bars ->UMAGDXC-440
  background-color: transparent;
}
